(function () {
  'use strict';

  const normalizeLabel = (value) =>
    String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/:$/, '')
      .trim()
      .toLowerCase();

  const observedRoots = new WeakSet();

  function isCaratRow(row) {
    if (!(row instanceof HTMLElement)) return false;

    const label = Array.from(row.children).find((element) =>
      element.classList?.contains('title-option')
    );

    if (!label) return false;
    const normalizedLabel = normalizeLabel(label.textContent);

    return normalizedLabel === 'carat weight' ||
      normalizedLabel === 'cart weight' ||
      normalizedLabel === 'total carat weight';
  }

  function getOpusRoot() {
    return document.getElementById('opus-shadow-container')?.shadowRoot || null;
  }

  function removeDuplicateCaratRows(root) {
    const optionRows = Array.from(
      root.querySelectorAll('.cd-product-item-options')
    ).filter(isCaratRow);

    const rowsByParent = new Map();

    optionRows.forEach((row) => {
      const parent = row.parentElement;
      if (!parent) return;
      if (!rowsByParent.has(parent)) rowsByParent.set(parent, []);
      rowsByParent.get(parent).push(row);
    });

    rowsByParent.forEach((caratRows) => {

      // Opus renders the Shopify variant first and line-item properties after
      // it. Keep the final row (the selected TCW property) and hide only the
      // preceding duplicate variant rows.
      caratRows.forEach((row, index) => {
        if (caratRows.length > 1 && index < caratRows.length - 1) {
          row.style.setProperty('display', 'none', 'important');
          row.dataset.caratDuplicateHidden = 'true';
        } else if (row.dataset.caratDuplicateHidden === 'true') {
          row.style.removeProperty('display');
          delete row.dataset.caratDuplicateHidden;
        }
      });
    });
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    new MutationObserver(scheduleCleanup).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  let scheduled = false;
  function scheduleCleanup() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      const opusRoot = getOpusRoot();

      observeRoot(document.documentElement);
      if (opusRoot) observeRoot(opusRoot);

      removeDuplicateCaratRows(document);
      if (opusRoot) removeDuplicateCaratRows(opusRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleCleanup, { once: true });
  } else {
    scheduleCleanup();
  }

  observeRoot(document.documentElement);
})();
